import React from 'react';
import TypingIndicator from './TypingIndicator';
import styles from './SplitThinkingIndicator.module.css';

interface SplitThinkingIndicatorProps {
  visible: boolean;
  message?: string;
}

const SplitThinkingIndicator: React.FC<SplitThinkingIndicatorProps> = ({ visible, message = 'Thinking' }) => {
  if (!visible) return null;
  return (
    <div className={`${styles.container} ${styles.compact}`}>
      <TypingIndicator visible={true} message={message} />
    </div>
  );
};

export default SplitThinkingIndicator;

